import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createUseStyles, Input, Modal, Switch, Text } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CreateViewModal');
const ViewConfirmModal = /*#__PURE__*/memo(_ref => {
  var _values$name;
  let {
    className,
    labels,
    isOpen,
    onSave,
    onClose,
    canManagePublicViews,
    canManagePrivateViews,
    inputAutoFocus = true
  } = _ref;
  let defaultIsPrivateValue = false;
  if (!canManagePublicViews && canManagePrivateViews) defaultIsPrivateValue = true;
  const classes = useStyles();
  const classNames = classnames(classes.root, className);
  const [values, setValues] = useState({
    isPrivate: defaultIsPrivateValue
  });
  const [isLoading, setIsLoading] = useState(false);
  const {
    t
  } = useWeb5Context();
  const onChange = useCallback(field => {
    return value => {
      const newInputValues = _objectSpread(_objectSpread({}, values), {}, {
        [field]: value
      });
      setValues(newInputValues);
    };
  }, [values]);
  const handleOnSave = useCallback(() => {
    if (!values['name']) return;
    setIsLoading(true);
    onSave && onSave(values).finally(() => {
      setIsLoading(false);
      onClose && onClose();
    });
  }, [values, onSave, onClose]);
  const handleOnClose = useCallback(() => {
    if (isLoading) return;
    onClose && onClose();
  }, [onClose, isLoading]);
  const newModalViewName = `${(labels === null || labels === void 0 ? void 0 : labels.viewName) || t('label_view_name')}*`;
  let canSave = false;
  if (values !== null && values !== void 0 && values.name && (values === null || values === void 0 ? void 0 : (_values$name = values.name) === null || _values$name === void 0 ? void 0 : _values$name.trim()) !== '') canSave = true;
  const isSwitchDisabled = useMemo(() => {
    if (canManagePublicViews !== canManagePrivateViews) return true;
    return false;
  }, [canManagePublicViews, canManagePrivateViews]);
  return /*#__PURE__*/React.createElement(Modal, {
    className: classNames,
    overlayClassName: classes.overlay,
    isOpen: isOpen,
    title: (labels === null || labels === void 0 ? void 0 : labels.title) || t('label_new_view'),
    confirmText: (labels === null || labels === void 0 ? void 0 : labels.confirmText) || t('action_save'),
    cancelText: (labels === null || labels === void 0 ? void 0 : labels.cancelText) || t('action_cancel'),
    onConfirm: handleOnSave,
    onCancel: handleOnClose,
    onRequestClose: handleOnClose,
    useCornerClose: false,
    isConfirmDisabled: isLoading || !canSave,
    isConfirmLoading: isLoading
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.inputOne
  }, /*#__PURE__*/React.createElement(Input, {
    label: newModalViewName,
    placeholder: (labels === null || labels === void 0 ? void 0 : labels.viewNamePlaceholder) || t('placeholder_text_field'),
    onChange: onChange('name'),
    value: values['name'] || '',
    isFullWidth: true,
    isReadOnly: isLoading,
    autoFocus: inputAutoFocus
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.inputTwo
  }, /*#__PURE__*/React.createElement(Text, null, (labels === null || labels === void 0 ? void 0 : labels.saveAs) || t('label_view_public_private_toggle')), /*#__PURE__*/React.createElement(Switch, {
    isDisabled: isLoading || isSwitchDisabled,
    onChange: onChange('isPrivate'),
    checked: values['isPrivate']
  })))));
});
process.env.NODE_ENV !== "production" ? ViewConfirmModal.propTypes = {
  className: PropTypes.string,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  labels: PropTypes.shape({
    title: PropTypes.string,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    viewName: PropTypes.string,
    saveAs: PropTypes.string,
    viewNamePlaceholder: PropTypes.string,
    saveAsPlaceholder: PropTypes.string
  })
} : void 0;
export default ViewConfirmModal;